import { RouteObject } from "react-router-dom";
import { DevelopmentSettingsPage } from "src/routes/developments/settings/DevelopmentSettingsPage";
import * as settingsPaths from "src/routing/domains/developments/settings/settingsPaths";

/**
 * SideNav leaf routes for development settings section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentSideNavLayout` in `detail/developmentDetail.ts`.
 */
export const settingsSideNavRoutes: RouteObject[] = [
  { path: settingsPaths.developmentSettingsRoute.path, Component: DevelopmentSettingsPage },
];
